export default {
  user: false,
};
